import { render, staticRenderFns } from "./EditHolidayDialog.vue?vue&type=template&id=1b636c97"
import script from "./EditHolidayDialog.vue?vue&type=script&lang=js"
export * from "./EditHolidayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports